export default "__VITE_ASSET__C3WFj2yJ__"